import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'fileToUrl',
})
export class FileToUrlPipe implements PipeTransform {
  transform(file: File): string {
    if (!file.type.startsWith('image/')) {
      throw new Error('File is not an image');
    }
    return URL.createObjectURL(file);
  }
}
